export function GooglePreview({
  title,
  description,
  path,
  locale,
}: {
  title: string;
  description: string;
  path: string;
  locale: string;
}) {
  const baseUrl = "https://endeksbilisim.com";
  const localePart = locale === "en" ? "/en" : "";
  const displayUrl = `${baseUrl}${localePart}${path}`;

  const truncatedTitle = title.length > 60 ? title.slice(0, 57) + "..." : title;
  const truncatedDesc = description.length > 160 ? description.slice(0, 157) + "..." : description;

  return (
    <div className="rounded-md border border-border bg-white p-4 font-sans">
      <p className="mb-0.5 truncate text-xs text-green-700">{displayUrl}</p>
      <p className="mb-1 text-lg font-normal leading-snug text-blue-700 hover:underline">
        {truncatedTitle}
      </p>
      <p className="text-sm leading-snug text-gray-600">{truncatedDesc}</p>
    </div>
  );
}
